import { render } from "./UpgradeSuccessModal.vue?vue&type=template&id=56c57a4a&scoped=true"
import script from "./UpgradeSuccessModal.vue?vue&type=script&lang=js"
export * from "./UpgradeSuccessModal.vue?vue&type=script&lang=js"

import "./UpgradeSuccessModal.vue?vue&type=style&index=0&id=56c57a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c57a4a"]])

export default __exports__